import React, { useState } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import { applyTestIdData } from 'Utilities/helpers';
import { TRACKING_ATTRIBUTE_NAME } from 'Utilities/hooks/useTrackElementVisibleOnce';

import { ReactComponent as MoneyHandIcon } from '../../moneyHandIcon.svg';
import paidListingsTexts from '../../paidListings.texts';

import { TAG_NAME } from './PaidListingInfoIcon.events';

import styles from './PaidListingInfoIcon.module.scss';

const LocalT = new MDText(paidListingsTexts);

export const PaidListingInfoIcon: React.FC = () => {
	const [isAnimating, setIsAnimating] = useState(false);

	const handleAnimationEnd = (e: React.AnimationEvent) => {
		if (e.animationName?.includes('move-money')) {
			setIsAnimating(false);
		}
	};

	const handleMouseEnter = () => {
		if (!isAnimating) {
			setIsAnimating(true);
		}
	};

	return (
		<div
			className={cx(styles.container, { [styles.isAnimatingIcon]: isAnimating })}
			onAnimationEnd={handleAnimationEnd}
			onMouseEnter={handleMouseEnter}
			{...applyTestIdData(cypressIds.containers.paidListingInfoIconContainer)}
			{...{ [TRACKING_ATTRIBUTE_NAME]: TAG_NAME }}
		>
			<MoneyHandIcon className={styles.icon} height={20} width={20} />
			<div className={styles.infoText}>{LocalT.translate(paidListingsTexts.infoIconTitle)}</div>
		</div>
	);
};
